const userProfileEndPoint = {
    updateProfile: (id) => ({
        url: `/updateUser/${id}`,
        method: "PUT",
    })
}

export default userProfileEndPoint